import { GradeAgeAlignmentComponent } from './grade-age-alignment/grade-age-alignment.component';
import { DataMonitoringEnrollmentsDividedComponent } from './data-monitoring-enrollments-divided/data-monitoring-enrollments-divided.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { DataMonitoringEnrollmentsSimplifiedComponent } from './data-monitoring-enrollments-simplified/data-monitoring-enrollments-simplified.component';
import { DataMonitoringEnrollmentsComponent } from './data-monitoring-enrollments/data-monitoring-enrollments.component';
import { DataMonitoringServicesComponent } from './data-monitoring-services/data-monitoring-services.component';
import { ProvisionalSchoolComponent } from './provisional-school/provisional-school.component';

const routes: Routes = [
    {
        path: 'grade-age-alignment',
        component: GradeAgeAlignmentComponent,
        canActivate: [AuthGuard] //, RouteGuardService
    },
    {
        path: 'r-enrolled-missing-ssid',
        component: DataMonitoringEnrollmentsDividedComponent,
        canActivate: [AuthGuard] //, RouteGuardService
    },
    {
        path: 'missing-withdrawal-date',
        component: DataMonitoringEnrollmentsComponent,
        canActivate: [AuthGuard] //, RouteGuardService
    },
    {
        path: 'missing-service-end-date',
        component: DataMonitoringServicesComponent,
        canActivate: [AuthGuard] // , RouteGuardService
    },
    {
        path: 'r-enrollment-not-eip',
        component: DataMonitoringEnrollmentsComponent,
        canActivate: [AuthGuard] //, RouteGuardService
    },
    {
        path: 'n-enrollment-not-eip',
        component: DataMonitoringEnrollmentsComponent,
        canActivate: [AuthGuard] // , RouteGuardService
    },
    {
        path: 'eip-n-enrollment',
        component: DataMonitoringEnrollmentsComponent,
        canActivate: [AuthGuard] //, RouteGuardService
    },
    {
        path: 'qad-age-eligible',
        component: DataMonitoringEnrollmentsComponent,
        canActivate: [AuthGuard] //, RouteGuardService
    },
    {
        path: 'duplicate-enrollment-line',
        component: DataMonitoringEnrollmentsSimplifiedComponent,
        canActivate: [AuthGuard] //, RouteGuardService
    },
    {
        path: 'duplicate-service',
        component: DataMonitoringServicesComponent,
        canActivate: [AuthGuard] //, RouteGuardService
    },
    {
        path: 'missing-departure-date-summer-intersession-service',
        component: DataMonitoringEnrollmentsComponent,
        canActivate: [AuthGuard] //, RouteGuardService
    },
    {
        path: 'eligible-enrolled-not-served',
        component: DataMonitoringEnrollmentsComponent,
        canActivate: [AuthGuard] //, RouteGuardService
    },
    {
        path: 'provisional-schools',
        component: ProvisionalSchoolComponent,
        canActivate: [AuthGuard] //, RouteGuardService
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DataMonitoringReportsRoutingModule {}
